import { StrategyEnum } from "./StrategyEnum";

export default class DeletionStrategy {
  strategyEnum: StrategyEnum = StrategyEnum.FirebaseStorage;
  video_id: string | null = null;
  path: string | null = null;
}
